'use client';

import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const MediaTimelineToolbar = ({ date, view }) => {
  const {
    pickerOpen,
    setPickerOpen,
    pickerType,
    selectedDate,
    handleDateChange,
    handlePrev,
    handleNext,
    getToolbarTitle,
    isDailyHours,
    setIsDailyHours,
  } = date;

  const { viewMode, setViewMode, VIEW_MODES } = view;
  const isToday =
    viewMode === VIEW_MODES.DAILY && dayjs(selectedDate).isSame(dayjs(), 'day');
  return (
    <div className="scheduler-toolbar">
      <div className="toolbar-period-picker">
        <button
          className="toolbar-period-btn"
          onClick={() => setPickerOpen(true)}
        >
          <span>{getToolbarTitle()}</span>

          {isToday && <span className="toolbar-today-badge">Today</span>}

          <i className="feather-chevron-down" />
        </button>

        <DatePicker
          open={pickerOpen}
          onOpenChange={setPickerOpen}
          picker={pickerType}
          value={dayjs(selectedDate)}
          onChange={handleDateChange}
          allowClear={false}
          style={{
            position: 'absolute',
            opacity: 0,
            width: 0,
            height: 0,
            pointerEvents: 'none',
          }}
        />

        <button className="toolbar-btn" onClick={handlePrev}>
          <i className="feather-chevron-left" />
        </button>

        <button className="toolbar-btn" onClick={handleNext}>
          <i className="feather-chevron-right" />
        </button>
      </div>

      <div
        className="scheduler-toolbar-right"
        style={{ display: 'flex', gap: '10px' }}
      >
        {viewMode === VIEW_MODES.DAILY && (
          <div className="view-toggle">
            <button
              className={`view-btn ${!isDailyHours ? 'active' : ''}`}
              onClick={() => setIsDailyHours(false)}
            >
              <i className="feather-clock  mr-1" />
              24 hours
            </button>

            <button
              className={`view-btn ${isDailyHours ? 'active' : ''}`}
              onClick={() => setIsDailyHours(true)}
            >
              <i className="feather-clock mr-1" />4 hours
            </button>
          </div>
        )}
        <select value={viewMode} onChange={(e) => setViewMode(e.target.value)}>
          <option value={VIEW_MODES.DAILY}>Daily</option>

          <option value={VIEW_MODES.WEEKLY}>Weekly</option>

          <option value={VIEW_MODES.MONTHLY}>Monthly</option>

          <option value={VIEW_MODES.YEARLY}>Yearly</option>
        </select>
      </div>
    </div>
  );
};

export default MediaTimelineToolbar;
